import { render, staticRenderFns } from "./CategoriasMenu.vue?vue&type=template&id=1bfb99b3&scoped=true"
import script from "./CategoriasMenu.vue?vue&type=script&lang=js"
export * from "./CategoriasMenu.vue?vue&type=script&lang=js"
import style0 from "./CategoriasMenu.vue?vue&type=style&index=0&id=1bfb99b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfb99b3",
  null
  
)

export default component.exports